/** Unit price for an order line from API (OrderItem.unitPriceCents) or legacy/cart drafts (priceCents). */
export const getOrderItemUnitPriceCents = (item: {
  unitPriceCents?: number | null;
  priceCents?: number | null;
}): number => Number(item?.unitPriceCents ?? item?.priceCents ?? 0);

/** Line subtotal in cents (qty × unit when lineSubtotalCents not provided by API). */
export const getOrderItemLineSubtotalCents = (item: {
  lineSubtotalCents?: number | null;
  unitPriceCents?: number | null;
  priceCents?: number | null;
  quantity?: number | null;
}): number => {
  if (item?.lineSubtotalCents != null) return Number(item.lineSubtotalCents);
  const q = Number(item?.quantity ?? 0);
  return getOrderItemUnitPriceCents(item) * q;
};

export const getItemOptionElementPrice = (item: any) => {
  const qty = Number(item?.quantity || 0);
  if (item?.lineSubtotalCents != null) {
    return Number(item.lineSubtotalCents);
  }
  if (item?.unitPriceCents != null) {
    return Number(item.unitPriceCents) * qty;
  }

  let elementPrice = 0;

  if (item?.itemOptionElements) {
    const elements = item.itemOptionElements.split(",");

    for (const element of elements) {
      const [priceCents, quantity] = element.split("::");
      elementPrice += (Number(priceCents) || 0) * (Number(quantity) || 0);
    }
  }
  return (Number(item?.priceCents || 0) + elementPrice) * qty;
};

export const itemsTotalPriceCalc = (items: any) =>
  items?.reduce((acc: any, item: any) => {
    const getTotalPrice = getItemOptionElementPrice(item);
    return acc + +(getTotalPrice || 0);
  }, 0);

export const itemTotalTaxCalc = (items: any) =>
  items?.reduce((acc: any, item: any) => {
    const getTotalPrice = getItemOptionElementPrice(item);
    return acc + +(getTotalPrice || 0) * +(item?.taxRate || 0);
  }, 0);
